/**
 * Cache cliente para catálogos invariantes durante la sesión.
 *
 * El `httpInterceptorService` usa este servicio para inyectar `request.cache`
 * automáticamente en peticiones GET a un conjunto cerrado de endpoints
 * catálogo (allowlist). Permite invalidar entradas cuando un administrador
 * edita un catálogo desde la propia aplicación.
 *
 * AB#2892
 */
angular.module("app")
    .factory('lookupCacheService', ['$cacheFactory', function ($cacheFactory) {
        const cache = $cacheFactory('lookupCache');

        const allowlist: string[] = [
            'PersonsTreatments',
            'Languages',
            'EventHosts',
            'EventsTypes',
            'InformationsGroups',
            'Configurations',
            'Companies',
            'Institutions',
            'Groups/GetGroupsPositions',
        ];

        function pathOf(url: string): string {
            const apiBase = (window as any).CONFIG?.api_url || '';
            let path = url;
            const qIdx = path.indexOf('?');
            if (qIdx >= 0) {
                path = path.substring(0, qIdx);
            }
            if (apiBase && path.indexOf(apiBase) === 0) {
                path = path.substring(apiBase.length);
            }
            while (path.charAt(0) === '/') {
                path = path.substring(1);
            }
            return path;
        }

        function matches(path: string, pattern: string): boolean {
            return path === pattern
                || path.indexOf(pattern + '/') === 0
                || path.indexOf(pattern + '?') === 0;
        }

        function shouldCache(method: string, url: string): boolean {
            if (!method || method.toUpperCase() !== 'GET') {
                return false;
            }
            const path = pathOf(url);
            for (let i = 0; i < allowlist.length; i++) {
                if (matches(path, allowlist[i])) {
                    return true;
                }
            }
            return false;
        }

        return {
            cache: cache,
            shouldCache: shouldCache,

            /** Vacía todo el cache (logout, cambio de empresa). */
            clearAll: function () {
                cache.removeAll();
            },

            /**
             * Invalida entradas cuyo path coincida con el patrón.
             * Ej.: `clear('Languages')` tras editar un idioma.
             */
            clear: function (pattern: string) {
                const keys: string[] = (cache as any).keys ? (cache as any).keys() : [];
                for (let i = 0; i < keys.length; i++) {
                    if (matches(pathOf(keys[i]), pattern)) {
                        cache.remove(keys[i]);
                    }
                }
            },
        };
    }]);
